<template name="primaryVisitorExtraField">
  <div class="primary-visitor-extra-field" v-show="hasMaterialsToFill">
    <div class="row" @click="togglePrimaryVisitorExtraField">
      <div class="title col-9">
        {{$t('ImproveInfo')}}
      </div>
      <div class="col-3">
        <i class="iconfont" :class="showPrimaryVisitorExtraField ? 'icon-up' : 'icon-down'"></i>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="" v-show="showPrimaryVisitorExtraField">
        <slot></slot> <!-- left for addVisitorDetail component -->
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'primaryVisitorExtraField',
  props: {
    showPrimaryVisitorExtraField: Boolean,
    hasMaterialsToFill: Boolean,
  },
  data() {
    return {
    };
  },
  methods: {
    togglePrimaryVisitorExtraField() {
      this.$emit('togglePrimaryVisitorExtraField');
    },
  },
};
</script>

<style scoped lang="scss">
  .primary-visitor-extra-field {
    border-top: 1px solid #f0f1f2;
    padding-top: 12px;
    padding-bottom: 12px;
    .row {
      margin: auto;
      .title {
        color: #4a4a4a;
        font-size: 14px;
        padding-left: 20px;
        background: url(../assets/images/edit.png) no-repeat left center;
        background-size: 16px auto;
        font-weight: bold;
        line-height: 24px;
      }
      .col-3 {
        i {
          font-size: 12px;
          padding-left: 2.5vw;
          display: inline-block;
          transform: scale(0.75, 0.75);
        }
        padding: 0;
        text-align: right;
      }
    }
  }
</style>
